import { render, staticRenderFns } from "./lxwm.vue?vue&type=template&id=2751bf7e&"
import script from "./lxwm.vue?vue&type=script&lang=js&"
export * from "./lxwm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports